import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a4e9b18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "shippingForm",
  class: "card p-6 sm:p-8 mb-4"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-main w-full" }, "การจัดส่ง และที่อยู่ผู้รับ")
], -1))
const _hoisted_5 = { class: "flex flex-col py-4 p-0 sm:p-6" }
const _hoisted_6 = { class: "flex flex-col gap-3 lg:flex-row lg:gap-0 items-start lg:items-center h-auto lg:h-10 mb-7" }
const _hoisted_7 = { class: "text-gray-400 flex-none w-full lg:w-32 text-base" }
const _hoisted_8 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_9 = { class: "flex sm:flex-1 gap-4 items-center" }
const _hoisted_10 = {
  key: 0,
  class: "flex-auto text-base"
}
const _hoisted_11 = {
  key: 1,
  class: "grid grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 gap-4 w-full"
}
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "mt-1 flex gap-1 items-center text-red-500 absolute"
}
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col relative"
}
const _hoisted_16 = { class: "flex flex-col gap-3 lg:flex-row lg:gap-0 items-start lg:items-center h-auto lg:h-10 mb-7" }
const _hoisted_17 = { class: "text-gray-400 flex-none w-full lg:w-32 text-base" }
const _hoisted_18 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_19 = {
  key: 0,
  class: "flex-auto text-base"
}
const _hoisted_20 = {
  key: 1,
  class: "flex flex-col relative w-full"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "mt-1 flex gap-1 items-center text-red-500 absolute"
}
const _hoisted_23 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-16 sm:w-32 flex-shrink-0 hidden lg:block" }, null, -1))
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = { class: "flex flex-col gap-0 md:flex-row md:gap-4" }
const _hoisted_27 = { class: "flex flex-col relative w-full" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "mt-1 flex gap-1 items-center text-red-500 absolute"
}
const _hoisted_30 = { class: "flex flex-col relative w-full" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 0,
  class: "mt-1 flex gap-1 items-center text-red-500 absolute"
}
const _hoisted_33 = { class: "flex flex-col gap-0 md:flex-row md:gap-4" }
const _hoisted_34 = { class: "flex flex-col relative w-full" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 0,
  class: "mt-1 flex gap-1 items-center text-red-500 absolute"
}
const _hoisted_37 = { class: "flex flex-col relative w-full" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 0,
  class: "mt-1 flex gap-1 items-center text-red-500 absolute"
}
const _hoisted_40 = { class: "flex flex-col gap-3 lg:flex-row lg:gap-0 items-start lg:items-center h-auto lg:h-10 mb-7" }
const _hoisted_41 = { class: "text-gray-400 flex-none w-24 sm:w-32 text-base" }
const _hoisted_42 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_43 = {
  key: 0,
  class: "flex-auto text-base"
}
const _hoisted_44 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 gap-4 w-full"
}
const _hoisted_45 = { class: "col-span-1" }
const _hoisted_46 = {
  key: 0,
  class: "mt-1 flex gap-1 items-center text-red-500 absolute"
}
const _hoisted_47 = { class: "flex flex-col gap-3 lg:flex-row lg:gap-0 items-start lg:items-center h-auto lg:h-10 mb-7" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 flex-none w-24 sm:w-32 text-base" }, "อีเมล", -1))
const _hoisted_49 = {
  key: 0,
  class: "flex-auto text-base"
}
const _hoisted_50 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 gap-4 w-full"
}
const _hoisted_51 = { class: "col-span-1" }
const _hoisted_52 = {
  key: 0,
  class: "mt-1 flex gap-1 items-center text-red-500 absolute"
}
const _hoisted_53 = { class: "flex flex-col space-y-4" }
const _hoisted_54 = {
  key: 0,
  class: "text-gray-400 flex-auto text-base"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_56 = {
  key: 1,
  class: "text-gray-400 flex-auto text-base"
}
const _hoisted_57 = {
  key: 2,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
}
const _hoisted_58 = ["id", "onClick"]
const _hoisted_59 = { class: "flex space-x-4 items-center" }
const _hoisted_60 = { class: "relative" }
const _hoisted_61 = ["src", "onerror"]
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "w-full flex flex-col text-left gap-1" }
const _hoisted_64 = { class: "flex justify-between" }
const _hoisted_65 = { class: "clamp-1" }
const _hoisted_66 = { class: "flex flex-col text-left gap-2" }
const _hoisted_67 = { class: "text-xs text-gray-500" }
const _hoisted_68 = { class: "text-xs text-gray-500" }
const _hoisted_69 = ["onClick", "id"]
const _hoisted_70 = { class: "flex h-full space-x-4 items-center" }
const _hoisted_71 = { class: "relative" }
const _hoisted_72 = ["src", "onerror"]
const _hoisted_73 = ["src"]
const _hoisted_74 = { class: "w-full flex flex-col text-left gap-1" }
const _hoisted_75 = { class: "flex justify-between" }
const _hoisted_76 = { class: "clamp-1" }
const _hoisted_77 = { class: "flex flex-col text-left gap-2" }
const _hoisted_78 = { class: "text-xs text-gray-500" }
const _hoisted_79 = { class: "text-xs text-gray-500" }
const _hoisted_80 = {
  key: 2,
  class: "absolute right-1 bottom-2"
}
const _hoisted_81 = { class: "relative col-info" }
const _hoisted_82 = ["src"]
const _hoisted_83 = { class: "popoverIcon absolute right-2 md:left-2 bottom-0 z-40" }
const _hoisted_84 = { class: "m-2 custom-input-trigger w-80" }
const _hoisted_85 = { class: "flex flex-col" }
const _hoisted_86 = { class: "mt-4" }
const _hoisted_87 = { class: "rounded-md bg-white p-3 border" }
const _hoisted_88 = {
  key: 0,
  class: "my-1 flex flex-row"
}
const _hoisted_89 = { class: "text-sm" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_91 = {
  key: 3,
  class: "absolute right-1 bottom-2"
}
const _hoisted_92 = { class: "relative col-info" }
const _hoisted_93 = ["src"]
const _hoisted_94 = { class: "popoverIcon absolute right-2 md:left-2 bottom-0 z-40" }
const _hoisted_95 = { class: "m-2 custom-input-trigger w-60 sm:w-80" }
const _hoisted_96 = { class: "flex flex-col" }
const _hoisted_97 = { class: "mt-4" }
const _hoisted_98 = { class: "rounded-md bg-white p-3 border" }
const _hoisted_99 = { class: "flex flex-row" }
const _hoisted_100 = {
  key: 0,
  class: "text-base text-center w-1/2 font-semibold text-gray-500"
}
const _hoisted_101 = {
  key: 1,
  class: "text-base text-center w-1/2 font-semibold text-gray-500"
}
const _hoisted_102 = {
  key: 2,
  class: "text-base text-center w-1/2 font-semibold text-gray-500"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base text-center w-1/2 font-semibold text-gray-500" }, " ค่าจัดส่ง ", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_105 = { class: "flex flex-row my-1" }
const _hoisted_106 = { class: "text-sm text-center w-1/2" }
const _hoisted_107 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_108 = {
  key: 1,
  class: "text-sm text-center w-1/2"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_110 = {
  key: 1,
  class: "flex flex-row my-1"
}
const _hoisted_111 = { class: "text-sm text-center w-1/2" }
const _hoisted_112 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_113 = {
  key: 1,
  class: "text-sm text-center w-1/2"
}
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border border-gray-200" }, null, -1))
const _hoisted_115 = { class: "mt-3 flex flex-row" }
const _hoisted_116 = { class: "text-sm" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_118 = { class: "flex flex-row my-1" }
const _hoisted_119 = { class: "text-sm text-center w-1/2" }
const _hoisted_120 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_121 = {
  key: 1,
  class: "text-sm text-center w-1/2"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_123 = {
  key: 1,
  class: "flex flex-row my-1"
}
const _hoisted_124 = { class: "text-sm text-center w-1/2" }
const _hoisted_125 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_126 = {
  key: 1,
  class: "text-sm text-center w-1/2"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border border-gray-200" }, null, -1))
const _hoisted_128 = { class: "mt-3 flex flex-row" }
const _hoisted_129 = { class: "text-sm" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_131 = { class: "flex flex-row my-1" }
const _hoisted_132 = { class: "text-sm text-center w-1/2" }
const _hoisted_133 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_134 = {
  key: 1,
  class: "text-sm text-center w-1/2"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_136 = {
  key: 1,
  class: "flex flex-row my-1"
}
const _hoisted_137 = { class: "text-sm text-center w-1/2" }
const _hoisted_138 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_139 = {
  key: 1,
  class: "text-sm text-center w-1/2"
}
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border border-gray-200" }, null, -1))
const _hoisted_141 = { class: "mt-3 flex flex-row" }
const _hoisted_142 = { class: "text-sm" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_144 = {
  key: 3,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
}
const _hoisted_145 = { class: "relative" }
const _hoisted_146 = { class: "border-2 rounded-md border-gray-100 p-1" }
const _hoisted_147 = { class: "flex space-x-4 items-center" }
const _hoisted_148 = { class: "relative" }
const _hoisted_149 = ["src", "onerror"]
const _hoisted_150 = ["src"]
const _hoisted_151 = { class: "w-full flex flex-col text-left gap-1" }
const _hoisted_152 = { class: "flex justify-between" }
const _hoisted_153 = { class: "clamp-1" }
const _hoisted_154 = { class: "flex flex-col text-left gap-2" }
const _hoisted_155 = { class: "text-xs text-gray-500" }
const _hoisted_156 = { class: "text-xs text-gray-500" }
const _hoisted_157 = {
  key: 0,
  class: "absolute right-1 bottom-2"
}
const _hoisted_158 = { class: "relative col-info" }
const _hoisted_159 = ["src"]
const _hoisted_160 = { class: "popoverIcon absolute right-2 md:left-2 bottom-0 z-40" }
const _hoisted_161 = { class: "m-2 custom-input-trigger w-60 sm:w-80" }
const _hoisted_162 = { class: "flex flex-col" }
const _hoisted_163 = { class: "mt-4" }
const _hoisted_164 = { class: "rounded-md bg-white p-3 border" }
const _hoisted_165 = { class: "flex flex-row" }
const _hoisted_166 = {
  key: 0,
  class: "text-base text-center w-1/2 font-semibold text-gray-500"
}
const _hoisted_167 = {
  key: 1,
  class: "text-base text-center w-1/2 font-semibold text-gray-500"
}
const _hoisted_168 = {
  key: 2,
  class: "text-base text-center w-1/2 font-semibold text-gray-500"
}
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base text-center w-1/2 font-semibold text-gray-500" }, " ค่าจัดส่ง ", -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_171 = { class: "flex flex-row my-1" }
const _hoisted_172 = { class: "text-sm text-center w-1/2" }
const _hoisted_173 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_175 = {
  key: 1,
  class: "flex flex-row my-1"
}
const _hoisted_176 = { class: "text-sm text-center w-1/2" }
const _hoisted_177 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border border-gray-200" }, null, -1))
const _hoisted_179 = { class: "mt-3 flex flex-row" }
const _hoisted_180 = { class: "text-sm" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_182 = { class: "flex flex-row my-1" }
const _hoisted_183 = { class: "text-sm text-center w-1/2" }
const _hoisted_184 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_186 = {
  key: 1,
  class: "flex flex-row my-1"
}
const _hoisted_187 = { class: "text-sm text-center w-1/2" }
const _hoisted_188 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border border-gray-200" }, null, -1))
const _hoisted_190 = { class: "mt-3 flex flex-row" }
const _hoisted_191 = { class: "text-sm" }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_193 = { class: "flex flex-row my-1" }
const _hoisted_194 = { class: "text-sm text-center w-1/2" }
const _hoisted_195 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_197 = {
  key: 1,
  class: "flex flex-row my-1"
}
const _hoisted_198 = { class: "text-sm text-center w-1/2" }
const _hoisted_199 = {
  key: 0,
  class: "text-sm text-center w-1/2"
}
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border border-gray-200" }, null, -1))
const _hoisted_201 = { class: "mt-3 flex flex-row" }
const _hoisted_202 = { class: "text-sm" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_204 = { key: 4 }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 flex gap-1 items-center text-red-500 absolute" }, /*#__PURE__*/_toDisplayString("* กรุณาเลือกการจัดส่งสินค้า"), -1))
const _hoisted_206 = [
  _hoisted_205
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThailandAutoComplete = _resolveComponent("ThailandAutoComplete")!
  const _component_shippingConfirmDialog = _resolveComponent("shippingConfirmDialog")!

  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "bullet_main",
            src: require('@/assets/icon_bullet/shipping.svg'),
            alt: ""
          }, null, 8, _hoisted_3),
          _hoisted_4
        ]),
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode(" ผู้รับ "),
              (
              _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "*"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (
              _ctx.data.statusOrderOnBuyer !== _ctx.StatusOrderCustomer.B1_AwaitingConfirm
            )
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.data.customerContactInfo.fullName), 1))
                : _createCommentVNode("", true),
              (
              _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([
                  _ctx.formShipping.firstname.error ? 'inputError' : 'inputBorder'
                , "w-full p-3 rounded-md border"]),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formShipping.firstname.value) = $event)),
                        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.watch('firstname'))),
                        placeholder: "ชื่อจริง",
                        type: "text"
                      }, null, 34), [
                        [_vModelText, _ctx.formShipping.firstname.value]
                      ]),
                      (_ctx.formShipping.firstname.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_ctx.formShipping.firstname.error)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_ctx.formShipping.firstname.error), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (
                _ctx.data.statusOrderOnBuyer ==
                _ctx.StatusOrderCustomer.B1_AwaitingConfirm
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            placeholder: "นามสกุล",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formShipping.lastname.value) = $event)),
                            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.watch('lastname'))),
                            type: "text",
                            class: "inputBorder w-full p-3 rounded-md border"
                          }, null, 544), [
                            [_vModelText, _ctx.formShipping.lastname.value]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, [
              _createTextVNode(" ที่อยู่ "),
              (
              _ctx.data.statusOrderOnBuyer ==
                _ctx.StatusOrderCustomer.B1_AwaitingConfirm &&
              _ctx.func_service.validatePickup(this.dataSelectShipping, _ctx.data)
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "*"))
                : _createCommentVNode("", true)
            ]),
            (
            _ctx.data.statusOrderOnBuyer !== _ctx.StatusOrderCustomer.B1_AwaitingConfirm
          )
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.data.customerContactInfo.shippingAddress[0].addrFull ||
            _ctx.data.customerContactInfo.shippingAddress[0].tambon ||
            _ctx.data.customerContactInfo.shippingAddress[0].amphoe ||
            _ctx.data.customerContactInfo.shippingAddress[0].province ||
            _ctx.data.customerContactInfo.shippingAddress[0].postcode
              ? _ctx.data.customerContactInfo.shippingAddress[0].addrFull +
                " " +
                _ctx.data.customerContactInfo.shippingAddress[0].tambon +
                " " +
                _ctx.data.customerContactInfo.shippingAddress[0].amphoe +
                " " +
                _ctx.data.customerContactInfo.shippingAddress[0].province +
                " " +
                _ctx.data.customerContactInfo.shippingAddress[0].postcode
              : "-"), 1))
              : _createCommentVNode("", true),
            (
            _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "ที่อยู่",
                    class: _normalizeClass([_ctx.formShipping.address.error ? 'inputError' : 'inputBorder', "w-full p-3 rounded-md border"]),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formShipping.address.value) = $event)),
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.watch('address'))),
                    type: "text"
                  }, null, 34), [
                    [_vModelText, _ctx.formShipping.address.value]
                  ]),
                  (_ctx.formShipping.address.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (_ctx.formShipping.address.error)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(_ctx.formShipping.address.error), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_ThailandAutoComplete, {
                        modelValue: _ctx.formShipping.tambon.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formShipping.tambon.value) = $event)),
                        value: _ctx.formShipping.tambon.value,
                        type: "district",
                        onSelect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.select($event))),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeAddress($event, _ctx.formShipping.tambon))),
                        label: "ตำบล",
                        size: "medium",
                        placeholder: "ตำบล"
                      }, {
                        validator: _withCtx(() => [
                          (_ctx.formShipping.tambon.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                (_ctx.formShipping.tambon.error)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(_ctx.formShipping.tambon.error), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_ThailandAutoComplete, {
                        modelValue: _ctx.formShipping.amphoe.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formShipping.amphoe.value) = $event)),
                        value: _ctx.formShipping.amphoe.value,
                        type: "amphoe",
                        onSelect: _cache[10] || (_cache[10] = ($event: any) => (_ctx.select($event))),
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeAddress($event, _ctx.formShipping.amphoe))),
                        label: "อำเภอ",
                        size: "medium",
                        placeholder: "อำเภอ"
                      }, {
                        validator: _withCtx(() => [
                          (_ctx.formShipping.amphoe.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                (_ctx.formShipping.amphoe.error)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_32, _toDisplayString(_ctx.formShipping.amphoe.error), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_ThailandAutoComplete, {
                        modelValue: _ctx.formShipping.province.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formShipping.province.value) = $event)),
                        value: _ctx.formShipping.province.value,
                        type: "province",
                        onSelect: _cache[13] || (_cache[13] = ($event: any) => (_ctx.select($event))),
                        onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeAddress($event, _ctx.formShipping.province))),
                        label: "จังหวัด",
                        size: "medium",
                        color: "#35495e",
                        placeholder: "จังหวัด"
                      }, {
                        validator: _withCtx(() => [
                          (_ctx.formShipping.province.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                (_ctx.formShipping.province.error)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_36, _toDisplayString(_ctx.formShipping.province.error), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_ThailandAutoComplete, {
                        modelValue: _ctx.formShipping.postalcode.value,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formShipping.postalcode.value) = $event)),
                        value: _ctx.formShipping.postalcode.value,
                        type: "zipcode",
                        onSelect: _cache[16] || (_cache[16] = ($event: any) => (_ctx.select($event))),
                        onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeAddress($event, _ctx.formShipping.postalcode))),
                        label: "รหัสไปรษณีย์",
                        size: "medium",
                        color: "#00a4e4",
                        placeholder: "รหัสไปรษณีย์"
                      }, {
                        validator: _withCtx(() => [
                          (_ctx.formShipping.postalcode.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                (_ctx.formShipping.postalcode.error)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_39, _toDisplayString(_ctx.formShipping.postalcode.error), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "value"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("p", _hoisted_41, [
              _createTextVNode(" เบอร์โทร "),
              (
              _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_42, "*"))
                : _createCommentVNode("", true)
            ]),
            (
            _ctx.data.statusOrderOnBuyer !== _ctx.StatusOrderCustomer.B1_AwaitingConfirm
          )
              ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.checkIsArray(_ctx.data.customerContactInfo.shippingAddress[0].mobiles)
              .replace(/[^0-9]/g, "")
              .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")), 1))
              : _createCommentVNode("", true),
            (
            _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      placeholder: "เบอร์โทร",
                      class: _normalizeClass([_ctx.formShipping.phone.error ? 'inputError' : 'inputBorder', "w-full p-3 rounded-md border"]),
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formShipping.phone.value) = $event)),
                      onInput: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.acceptNumber && _ctx.acceptNumber(...args))),
                      type: "text",
                      maxlength: "12"
                    }, null, 34), [
                      [_vModelText, _ctx.formShipping.phone.value]
                    ]),
                    (_ctx.formShipping.phone.error)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_46, _toDisplayString(_ctx.formShipping.phone.error), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            (
            _ctx.data.statusOrderOnBuyer !== _ctx.StatusOrderCustomer.B1_AwaitingConfirm
          )
              ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(_ctx.checkIsArray(_ctx.data.customerContactInfo.shippingAddress[0].emails) ||
            "-"), 1))
              : _createCommentVNode("", true),
            (
            _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _withDirectives(_createElementVNode("input", {
                      placeholder: "อีเมล",
                      class: _normalizeClass([_ctx.formShipping.email.error ? 'inputError' : 'inputBorder', "w-full p-3 rounded-md border"]),
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formShipping.email.value) = $event)),
                      onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.watch('email'))),
                      type: "text"
                    }, null, 34), [
                      [_vModelText, _ctx.formShipping.email.value]
                    ]),
                    (_ctx.formShipping.email.error)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_52, _toDisplayString(_ctx.formShipping.email.error), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_53, [
            (!_ctx.data.hasNoShipment)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (
              _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm
            )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_54, [
                        _createTextVNode(" เลือกการจัดส่งสินค้า "),
                        _hoisted_55
                      ]))
                    : _createCommentVNode("", true),
                  (
              _ctx.data.statusOrderOnBuyer !== _ctx.StatusOrderCustomer.B1_AwaitingConfirm
            )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_56, " การจัดส่งสินค้า "))
                    : _createCommentVNode("", true),
                  (
              _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.shippingAvailableData, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.shippingMethodId,
                            class: "relative"
                          }, [
                            (_ctx.data.shippingAvailableData.length == 1)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  id: item.shippingMethodId,
                                  onClick: ($event: any) => (_ctx.selectShipping(item.shippingMethodId, item, _ctx.data)),
                                  class: "border-green-island-500 bg-green-island-100 cursor-pointer border-2 rounded-md p-1"
                                }, [
                                  _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("img", {
                                        class: "min-w-14 max-w-14 min-h-14 max-h-14 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                        src: _ctx.prefixUrlImage + item.shippingIconUrl,
                                        onerror: `this.src='${_ctx.envMedia}/public/icons/web/empty.png'`
                                      }, null, 8, _hoisted_61),
                                      (item.isCOD)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            style: {"width":"24px","height":"12px","padding-right":"0.05rem"},
                                            class: "absolute top-1 right-0",
                                            src: require('@/assets/images/icon-cod2.png')
                                          }, null, 8, _hoisted_62))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("p", _hoisted_65, _toDisplayString(item.shippingAliasName), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_66, [
                                        _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.func_service.setData(item)), 1),
                                        _createElementVNode("p", _hoisted_68, " ระยะเวลาจัดส่ง " + _toDisplayString(item.deliveryTime.earliest) + " - " + _toDisplayString(item.deliveryTime.last) + " วัน ", 1)
                                      ])
                                    ])
                                  ])
                                ], 8, _hoisted_58))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.selectShipping(item.shippingMethodId, item, _ctx.data)),
                                  id: item.shippingMethodId,
                                  class: _normalizeClass([
                    _ctx.inpRadShipping === item.shippingMethodId
                      ? 'border-green-island-500  bg-green-island-100'
                      : ''
                  , "cursor-pointer h-full border-2 rounded-md border-gray-100 p-1"])
                                }, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("img", {
                                        class: "min-w-14 max-w-14 min-h-14 max-h-14 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                        src: _ctx.prefixUrlImage + item.shippingIconUrl,
                                        onerror: `this.src='${_ctx.envMedia}/public/icons/web/empty.png'`
                                      }, null, 8, _hoisted_72),
                                      (item.isCOD)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            style: {"width":"24px","height":"12px","padding-right":"0.05rem"},
                                            class: "absolute top-1 right-0",
                                            src: require('@/assets/images/icon-cod2.png')
                                          }, null, 8, _hoisted_73))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_74, [
                                      _createElementVNode("div", _hoisted_75, [
                                        _createElementVNode("p", _hoisted_76, _toDisplayString(item.shippingAliasName), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_77, [
                                        _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.func_service.setData(item)), 1),
                                        _createElementVNode("p", _hoisted_79, " ระยะเวลาจัดส่ง " + _toDisplayString(item.deliveryTime.earliest) + " - " + _toDisplayString(item.deliveryTime.last) + " วัน ", 1)
                                      ])
                                    ])
                                  ])
                                ], 10, _hoisted_69)),
                            (
                  (item.shippingMethodType == 'fixedRate' ||
                    item.shippingMethodType == 'basedByPcs') &&
                  item.shippingMethodAttribute.minOrderTotalAmount > 0
                )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                  _createElementVNode("div", _hoisted_81, [
                                    _createElementVNode("img", {
                                      class: "w-4 h-4",
                                      src: require('@/assets/images/question_showship.svg'),
                                      alt: ""
                                    }, null, 8, _hoisted_82),
                                    _createElementVNode("div", _hoisted_83, [
                                      _createElementVNode("div", _hoisted_84, [
                                        _createElementVNode("div", _hoisted_85, [
                                          _createElementVNode("div", _hoisted_86, [
                                            _createElementVNode("div", _hoisted_87, [
                                              (
                                  item.shippingMethodAttribute
                                    .minOrderTotalAmount
                                )
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                                    _createElementVNode("p", _hoisted_89, [
                                                      _hoisted_90,
                                                      _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                        item.shippingMethodAttribute
                                          .minOrderTotalAmount
                                      )) + " บาท จัดส่งฟรี ", 1)
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                  item.shippingMethodType == 'basedByStepPcs' ||
                  item.shippingMethodType == 'basedByStepWeight' ||
                  item.shippingMethodType == 'basedByOrderPrice'
                )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                  _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("img", {
                                      class: "w-4 h-4",
                                      src: require('@/assets/images/question_showship.svg'),
                                      alt: ""
                                    }, null, 8, _hoisted_93),
                                    _createElementVNode("div", _hoisted_94, [
                                      _createElementVNode("div", _hoisted_95, [
                                        _createElementVNode("div", _hoisted_96, [
                                          _createElementVNode("div", _hoisted_97, [
                                            _createElementVNode("div", _hoisted_98, [
                                              _createElementVNode("div", _hoisted_99, [
                                                (
                                  item.shippingMethodType == 'basedByStepPcs'
                                )
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_100, " คิดตามจำนวนสินค้า "))
                                                  : _createCommentVNode("", true),
                                                (
                                  item.shippingMethodType == 'basedByStepWeight'
                                )
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_101, " น้ำหนักสินค้า "))
                                                  : _createCommentVNode("", true),
                                                (
                                  item.shippingMethodType == 'basedByOrderPrice'
                                )
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_102, " ราคาสินค้ารวม "))
                                                  : _createCommentVNode("", true),
                                                _hoisted_103
                                              ]),
                                              _hoisted_104,
                                              (item.shippingMethodType == 'basedByStepPcs')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item
                                  .shippingMethodAttribute.shippingCost, (itemA, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                                        key: itemA.shippingMethodId
                                                      }, [
                                                        (
                                    index !=
                                    item.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createElementVNode("div", _hoisted_105, [
                                                                _createElementVNode("p", _hoisted_106, " ไม่เกิน " + _toDisplayString(_ctx.currency(itemA.minPcs)) + " ชิ้น ", 1),
                                                                (itemA.shippingCost)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString(_ctx.currency(itemA.shippingCost)) + " บาท ", 1))
                                                                  : _createCommentVNode("", true),
                                                                (!itemA.shippingCost)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_108, " จัดส่งฟรี "))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _hoisted_109
                                                            ], 64))
                                                          : _createCommentVNode("", true),
                                                        (
                                    index ==
                                    item.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                                              _createElementVNode("p", _hoisted_111, " เกิน " + _toDisplayString(_ctx.currency(itemA.minPcs)) + " ชิ้นขึ้นไป ", 1),
                                                              (itemA.shippingCost)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_112, _toDisplayString(_ctx.currency(itemA.shippingCost)) + " บาท ", 1))
                                                                : _createCommentVNode("", true),
                                                              (!itemA.shippingCost)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_113, " จัดส่งฟรี "))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128)),
                                                    (
                                  item.shippingMethodAttribute
                                    .minOrderTotalAmount
                                )
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _hoisted_114,
                                                          _createElementVNode("div", _hoisted_115, [
                                                            _createElementVNode("p", _hoisted_116, [
                                                              _hoisted_117,
                                                              _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                        item.shippingMethodAttribute
                                          .minOrderTotalAmount
                                      )) + " บาท จัดส่งฟรี ", 1)
                                                            ])
                                                          ])
                                                        ], 64))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                : _createCommentVNode("", true),
                                              (
                                item.shippingMethodType == 'basedByStepWeight'
                              )
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item
                                  .shippingMethodAttribute.shippingCost, (itemB, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                                        key: itemB.shippingMethodId
                                                      }, [
                                                        (
                                    index !=
                                    item.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createElementVNode("div", _hoisted_118, [
                                                                _createElementVNode("p", _hoisted_119, " ไม่เกิน " + _toDisplayString(_ctx.currency(itemB.minWeight)) + " กิโลกรัม ", 1),
                                                                (itemB.shippingCost)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_120, _toDisplayString(_ctx.currency(itemB.shippingCost)) + " บาท ", 1))
                                                                  : _createCommentVNode("", true),
                                                                (!itemB.shippingCost)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_121, " จัดส่งฟรี "))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _hoisted_122
                                                            ], 64))
                                                          : _createCommentVNode("", true),
                                                        (
                                    index ==
                                    item.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                                              _createElementVNode("p", _hoisted_124, " เกิน " + _toDisplayString(_ctx.currency(itemB.minWeight)) + " กิโลกรัม ขึ้นไป ", 1),
                                                              (itemB.shippingCost)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_125, _toDisplayString(_ctx.currency(itemB.shippingCost)) + " บาท ", 1))
                                                                : _createCommentVNode("", true),
                                                              (!itemB.shippingCost)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_126, " จัดส่งฟรี "))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128)),
                                                    (
                                  item.shippingMethodAttribute
                                    .minOrderTotalAmount
                                )
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _hoisted_127,
                                                          _createElementVNode("div", _hoisted_128, [
                                                            _createElementVNode("p", _hoisted_129, [
                                                              _hoisted_130,
                                                              _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                        item.shippingMethodAttribute
                                          .minOrderTotalAmount
                                      )) + " บาท จัดส่งฟรี ", 1)
                                                            ])
                                                          ])
                                                        ], 64))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                : _createCommentVNode("", true),
                                              (
                                item.shippingMethodType == 'basedByOrderPrice'
                              )
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item
                                  .shippingMethodAttribute.shippingCost, (itemC, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                                        key: itemC.shippingMethodId
                                                      }, [
                                                        (
                                    index !=
                                    item.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createElementVNode("div", _hoisted_131, [
                                                                _createElementVNode("p", _hoisted_132, " ไม่เกิน " + _toDisplayString(_ctx.currency(itemC.minOrderTotalAmount)) + " บาท ", 1),
                                                                (itemC.shippingCost)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_133, _toDisplayString(_ctx.currency(itemC.shippingCost)) + " บาท ", 1))
                                                                  : _createCommentVNode("", true),
                                                                (!itemC.shippingCost)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_134, " จัดส่งฟรี "))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _hoisted_135
                                                            ], 64))
                                                          : _createCommentVNode("", true),
                                                        (
                                    index ==
                                    item.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                                              _createElementVNode("p", _hoisted_137, " เกิน " + _toDisplayString(_ctx.currency(itemC.minOrderTotalAmount)) + " บาท ขึ้นไป ", 1),
                                                              (itemC.shippingCost)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_138, _toDisplayString(_ctx.currency(itemC.shippingCost)) + " บาท ", 1))
                                                                : _createCommentVNode("", true),
                                                              (!itemC.shippingCost)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_139, " จัดส่งฟรี "))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128)),
                                                    (
                                  item.shippingMethodAttribute
                                    .minOrderTotalAmount
                                )
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _hoisted_140,
                                                          _createElementVNode("div", _hoisted_141, [
                                                            _createElementVNode("p", _hoisted_142, [
                                                              _hoisted_143,
                                                              _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                        item.shippingMethodAttribute
                                          .minOrderTotalAmount
                                      )) + " บาท จัดส่งฟรี ", 1)
                                                            ])
                                                          ])
                                                        ], 64))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (
              _ctx.data.statusOrderOnBuyer !== _ctx.StatusOrderCustomer.B1_AwaitingConfirm
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                        _createElementVNode("div", _hoisted_145, [
                          _createElementVNode("div", _hoisted_146, [
                            _createElementVNode("div", _hoisted_147, [
                              _createElementVNode("div", _hoisted_148, [
                                (_ctx.data.shippingConfirmedData?.shippingIconUrl)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "min-w-14 max-w-14 min-h-14 max-h-14 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                      src: 
                        _ctx.prefixUrlImage +
                        _ctx.data.shippingConfirmedData?.shippingIconUrl
                      ,
                                      onerror: `this.src='${_ctx.envMedia}/public/icons/web/empty.png'`
                                    }, null, 8, _hoisted_149))
                                  : _createCommentVNode("", true),
                                (_ctx.data.shippingConfirmedData?.isCOD)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      style: {"width":"24px","height":"12px","padding-right":"0.05rem"},
                                      class: "absolute top-1 right-0",
                                      src: require('@/assets/images/icon-cod2.png')
                                    }, null, 8, _hoisted_150))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_151, [
                                _createElementVNode("div", _hoisted_152, [
                                  _createElementVNode("p", _hoisted_153, _toDisplayString(_ctx.data.shippingConfirmedData?.shippingAliasName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_154, [
                                  _createElementVNode("p", _hoisted_155, _toDisplayString(_ctx.func_service.setData(_ctx.data.shippingConfirmedData)), 1),
                                  _createElementVNode("p", _hoisted_156, " ระยะเวลาจัดส่ง " + _toDisplayString(_ctx.data.shippingConfirmedData?.deliveryTime.earliest) + " - " + _toDisplayString(_ctx.data.shippingConfirmedData?.deliveryTime.last) + " วัน ", 1)
                                ])
                              ])
                            ])
                          ]),
                          (
                  _ctx.data.shippingConfirmedData?.shippingMethodType ==
                    'basedByStepPcs' ||
                  _ctx.data.shippingConfirmedData?.shippingMethodType ==
                    'basedByStepWeight' ||
                  _ctx.data.shippingConfirmedData?.shippingMethodType ==
                    'basedByOrderPrice'
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                _createElementVNode("div", _hoisted_158, [
                                  _createElementVNode("img", {
                                    class: "w-4 h-4",
                                    src: require('@/assets/images/question_showship.svg'),
                                    alt: ""
                                  }, null, 8, _hoisted_159),
                                  _createElementVNode("div", _hoisted_160, [
                                    _createElementVNode("div", _hoisted_161, [
                                      _createElementVNode("div", _hoisted_162, [
                                        _createElementVNode("div", _hoisted_163, [
                                          _createElementVNode("div", _hoisted_164, [
                                            _createElementVNode("div", _hoisted_165, [
                                              (
                                  _ctx.data.shippingConfirmedData
                                    ?.shippingMethodType == 'basedByStepPcs'
                                )
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_166, " คิดตามจำนวนสินค้า "))
                                                : _createCommentVNode("", true),
                                              (
                                  _ctx.data.shippingConfirmedData
                                    ?.shippingMethodType == 'basedByStepWeight'
                                )
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_167, " น้ำหนักสินค้า "))
                                                : _createCommentVNode("", true),
                                              (
                                  _ctx.data.shippingConfirmedData
                                    ?.shippingMethodType == 'basedByOrderPrice'
                                )
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_168, " ราคาสินค้ารวม "))
                                                : _createCommentVNode("", true),
                                              _hoisted_169
                                            ]),
                                            _hoisted_170,
                                            (
                                _ctx.data.shippingConfirmedData
                                  ?.shippingMethodType == 'basedByStepPcs'
                              )
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data
                                  .shippingConfirmedData
                                  ?.shippingMethodAttribute.shippingCost, (itemA, index) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                                      key: itemA.shippingMethodId
                                                    }, [
                                                      (
                                    index !=
                                    _ctx.data.shippingConfirmedData
                                      ?.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createElementVNode("div", _hoisted_171, [
                                                              _createElementVNode("p", _hoisted_172, " ไม่เกิน " + _toDisplayString(itemA.minPcs) + " ชิ้น ", 1),
                                                              (itemA.shippingCost)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_173, _toDisplayString(_ctx.currency(itemA.shippingCost)) + " บาท ", 1))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _hoisted_174
                                                          ], 64))
                                                        : _createCommentVNode("", true),
                                                      (
                                    index ==
                                    _ctx.data.shippingConfirmedData
                                      ?.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                                            _createElementVNode("p", _hoisted_176, " เกิน " + _toDisplayString(itemA.minPcs) + " ชิ้นขึ้นไป ", 1),
                                                            (itemA.shippingCost)
                                                              ? (_openBlock(), _createElementBlock("p", _hoisted_177, _toDisplayString(_ctx.currency(itemA.shippingCost)) + " บาท ", 1))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ], 64))
                                                  }), 128)),
                                                  (
                                  _ctx.data.shippingConfirmedData
                                    ?.shippingMethodAttribute
                                    .minOrderTotalAmount
                                )
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _hoisted_178,
                                                        _createElementVNode("div", _hoisted_179, [
                                                          _createElementVNode("p", _hoisted_180, [
                                                            _hoisted_181,
                                                            _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                        _ctx.data.shippingConfirmedData
                                          ?.shippingMethodAttribute
                                          .minOrderTotalAmount
                                      )) + " บาท จัดส่งฟรี ", 1)
                                                          ])
                                                        ])
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (
                                _ctx.data.shippingConfirmedData
                                  ?.shippingMethodType == 'basedByStepWeight'
                              )
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data
                                  .shippingConfirmedData
                                  ?.shippingMethodAttribute.shippingCost, (itemB, index) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                                      key: itemB.shippingMethodId
                                                    }, [
                                                      (
                                    index !=
                                    _ctx.data.shippingConfirmedData
                                      ?.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createElementVNode("div", _hoisted_182, [
                                                              _createElementVNode("p", _hoisted_183, " ไม่เกิน " + _toDisplayString(itemB.minWeight) + " กิโลกรัม ", 1),
                                                              (itemB.shippingCost)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_184, _toDisplayString(_ctx.currency(itemB.shippingCost)) + " บาท ", 1))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _hoisted_185
                                                          ], 64))
                                                        : _createCommentVNode("", true),
                                                      (
                                    index ==
                                    _ctx.data.shippingConfirmedData
                                      ?.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                                            _createElementVNode("p", _hoisted_187, " เกิน " + _toDisplayString(itemB.minWeight) + " กิโลกรัม ขึ้นไป ", 1),
                                                            (itemB.shippingCost)
                                                              ? (_openBlock(), _createElementBlock("p", _hoisted_188, _toDisplayString(_ctx.currency(itemB.shippingCost)) + " บาท ", 1))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ], 64))
                                                  }), 128)),
                                                  (
                                  _ctx.data.shippingConfirmedData
                                    ?.shippingMethodAttribute
                                    .minOrderTotalAmount
                                )
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _hoisted_189,
                                                        _createElementVNode("div", _hoisted_190, [
                                                          _createElementVNode("p", _hoisted_191, [
                                                            _hoisted_192,
                                                            _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                        _ctx.data.shippingConfirmedData
                                          ?.shippingMethodAttribute
                                          .minOrderTotalAmount
                                      )) + " บาท จัดส่งฟรี ", 1)
                                                          ])
                                                        ])
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (
                                _ctx.data.shippingConfirmedData
                                  ?.shippingMethodType == 'basedByOrderPrice'
                              )
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data
                                  .shippingConfirmedData
                                  ?.shippingMethodAttribute.shippingCost, (itemC, index) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                                      key: itemC.shippingMethodId
                                                    }, [
                                                      (
                                    index !=
                                    _ctx.data.shippingConfirmedData
                                      ?.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createElementVNode("div", _hoisted_193, [
                                                              _createElementVNode("p", _hoisted_194, " ไม่เกิน " + _toDisplayString(_ctx.currency(itemC.minOrderTotalAmount)) + " บาท ", 1),
                                                              (itemC.shippingCost)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_195, _toDisplayString(_ctx.currency(itemC.shippingCost)) + " บาท ", 1))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _hoisted_196
                                                          ], 64))
                                                        : _createCommentVNode("", true),
                                                      (
                                    index ==
                                    _ctx.data.shippingConfirmedData
                                      ?.shippingMethodAttribute.shippingCost
                                      .length -
                                      1
                                  )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                                            _createElementVNode("p", _hoisted_198, " เกิน " + _toDisplayString(_ctx.currency(itemC.minOrderTotalAmount)) + " บาท ขึ้นไป ", 1),
                                                            (itemC.shippingCost)
                                                              ? (_openBlock(), _createElementBlock("p", _hoisted_199, _toDisplayString(_ctx.currency(itemC.shippingCost)) + " บาท ", 1))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ], 64))
                                                  }), 128)),
                                                  (
                                  _ctx.data.shippingConfirmedData
                                    ?.shippingMethodAttribute
                                    .minOrderTotalAmount
                                )
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _hoisted_200,
                                                        _createElementVNode("div", _hoisted_201, [
                                                          _createElementVNode("p", _hoisted_202, [
                                                            _hoisted_203,
                                                            _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                        _ctx.data.shippingConfirmedData
                                          ?.shippingMethodAttribute
                                          .minOrderTotalAmount
                                      )) + " บาท จัดส่งฟรี ", 1)
                                                          ])
                                                        ])
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
              !_ctx.inpRadShipping &&
              _ctx.data.statusOrderOnBuyer === _ctx.StatusOrderCustomer.B1_AwaitingConfirm
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_204, _hoisted_206))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_shippingConfirmDialog, { ref: "shippingDialog" }, null, 512)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}